import 'bootstrap';
import Chart from 'chart.js/auto'
import $ from './include/import-jquery';
import select2 from "select2";

select2($);

function handleCharactersCounters() {
    const characterCounters = document.querySelectorAll('.js-characterCounter');
    characterCounters.forEach(counter => {
        const field = <HTMLInputElement | HTMLTextAreaElement>counter.parentElement.parentElement.querySelector('.js-field');
        counter.innerHTML = field.value.length.toString();

        field.addEventListener('input', () => {
            counter.innerHTML = field.value.length.toString();
        });
    });
}

function handleBootstrapTabs() {
    const hash = location.hash.replace(/^#/, '');
    if (hash) {
        $('.nav-tabs a[href="#' + hash + '"]').tab('show');
    }

    $('.nav-tabs a').on('shown.bs.tab', e => {
        window.location.hash = e.target.hash;
    });
}

function onDeleteTimeSpent(e: Event) {
    const deleteTimeSpentBtn = <HTMLButtonElement>e.currentTarget;

    if (deleteTimeSpentBtn.dataset.id) {
        $.ajax({
            url: 'ajax/deleteTimeSpent.php',
            type: 'POST',
            data: {
                timeSpentId: deleteTimeSpentBtn.dataset.id
            },
            dataType: 'json',
            success: (response) => {
                console.log(response);
                if (response.status === 'success') {
                    deleteTimeSpentBtn.closest('.timeSpent').remove();
                }
            }
        });
    } else {
        deleteTimeSpentBtn.closest('.timeSpent').remove();
    }
}


window.addEventListener('load', () => {
    $('[title]').tooltip();
    $('.select2').select2({
        language: 'fr'
    });

    handleCharactersCounters();

    const charts = document.querySelectorAll('.js-chart');
    charts.forEach(chart => {
        const chartAsHTMLElement = <HTMLCanvasElement>chart;
        const score = chartAsHTMLElement.dataset.score;
        const loose = chartAsHTMLElement.dataset.loose;

        const chartAsHTMLCanvasElement = <HTMLCanvasElement>chart;
        const context = chartAsHTMLCanvasElement.getContext('2d');
        const resultGraph = new Chart(context, {
            type: 'pie',
            data: {
                labels: ['Réussite', 'Échec'],
                datasets: [{
                    label: '# of Votes',
                    data: [score, loose],
                    backgroundColor: [
                        'rgb(40, 167, 69)',
                        'rgb(220, 53, 69)'
                    ],
                    borderColor: [
                        'rgb(0,0,0)',
                        'rgb(0,0,0)'
                    ],
                    borderWidth: [
                        1,
                        1
                    ],
                }],
            },
            options: {
                backgroundColor: 'rbga(94,206,67)',
                responsive: false
            }
        });
    });

    const deleteTimeSpents = document.querySelectorAll('.deleteTimeSpent');
    deleteTimeSpents.forEach(deleteTimeSpent => {
        deleteTimeSpent.addEventListener('click', onDeleteTimeSpent);
    });

    const addTimeSpents = document.querySelectorAll('.addTimeSpent');
    addTimeSpents.forEach(addTimeSpents => {
        const addTimeSpent = <HTMLButtonElement>addTimeSpents;
        addTimeSpent.addEventListener('click', () => {
            const i = document.querySelectorAll('.timeSpent:not(.display-none)').length + '';

            const timeSpentsContainer = addTimeSpent.closest('.js-day-container').querySelector('.timeSpents-container');
            const emptyTimeSpent = timeSpentsContainer.querySelector('.timeSpent-empty');
            const emptyTimeSpentClone = <HTMLElement>emptyTimeSpent.cloneNode(true);
            emptyTimeSpentClone.querySelector('.deleteTimeSpent').addEventListener('click', onDeleteTimeSpent);
            timeSpentsContainer.appendChild(emptyTimeSpentClone);
            emptyTimeSpentClone.classList.remove('display-none');

            const inputLabelDatalists = emptyTimeSpentClone.querySelectorAll('.inputLabelDatalist-container');
            inputLabelDatalists.forEach(inputLabelDatalist => {
                const newName = inputLabelDatalist.querySelector('input').name.replace('new', i);

                const inputs = inputLabelDatalist.querySelectorAll('input');
                inputs.forEach(input => {
                    input.disabled = false;
                    input.name = input.id = input.list = newName;
                });

                const labels = inputLabelDatalist.querySelectorAll('label');
                labels.forEach(label => {
                    label.setAttribute("for", newName);
                });

                const datalists = inputLabelDatalist.querySelectorAll('datalist');
                datalists.forEach(datalist => {
                    datalist.id = newName;
                });
            });
        });
    });

    handleBootstrapTabs();
}, false);


